<div class="content-page">
  <!-- Header -->
  <div class="content-header">
    <h3 class="headline-title">Minisites</h3>
  </div>
  <!-- Header tabs -->
  <div class="content-header-tabs">
    <button class="tab" (click)="toggleTabs('production')" [ngClass]="{ active: tabs.active === 'production' }">
      Production
    </button>
    <button class="tab" (click)="toggleTabs('editor2dmaps')" [ngClass]="{ active: tabs.active === 'editor2dmaps' }">
      Editor 2D Map Demo
    </button>
    <button class="tab" (click)="toggleTabs('testing')" [ngClass]="{ active: tabs.active === 'testing' }">
      Testing
    </button>
    <button class="tab" (click)="toggleTabs('outdated')" [ngClass]="{ active: tabs.active === 'outdated' }">
      Outdated Sites
    </button>
  </div>

  <!-- Body -->
  <div class="content-body-tabs">
    <div class="content-headline">
      <div>
        <h3 class="headline-title">
          <span *ngIf="tabs.active === 'production'"> Production List </span>
          <span *ngIf="tabs.active === 'editor2dmaps'"> Editor 2D MAP Demo Sites List </span>
          <span *ngIf="tabs.active === 'testing'"> Testing Sites List </span>
          <span *ngIf="tabs.active === 'outdated'">
            Outdated Sites List: <span>List of sites with version prior to 1.0.0</span>
          </span>
        </h3>
      </div>
      <div class="d-flex align-items-center">
        <!-- Searcher -->
        <div class="input-wrapper mx-2" (keydown)="onSearch($event)">
          <!-- <i class="fa fa-search me-2" aria-hidden="true"></i> -->
          <img class="me-2" src="assets/img/icons/search-black.svg" alt="search black icon" />
          <input type="text" [(ngModel)]="searchParams.siteUrl" id="minisite-url" placeholder="Mini site url" />
        </div>
        <button class="btn-main" [routerLink]="['/sitesbuilder/private/workflows']">
          {{ 'workspace.sitesbuilder.list.createButton' | translate }}
          <img class="ms-2" src="assets/img/icons/plus-white.svg" alt="plus white icon" />
        </button>
      </div>
    </div>

    <div class="content-body">
      <!-- Table -->
      <div class="content-table">
        <table class="table table-borderless">
          <thead>
            <tr>
              <th colspan="2">{{ 'workspace.sitesbuilder.list.table.url' | translate }}</th>
              <th>{{ 'workspace.sitesbuilder.list.table.dvm' | translate }}</th>
              <th>{{ 'workspace.sitesbuilder.list.table.workflow' | translate }}</th>
              <th>{{ 'workspace.sitesbuilder.list.table.libversion' | translate }}</th>
              <th>{{ 'workspace.sitesbuilder.list.table.lastModification' | translate }}</th>
              <th class="th-center">{{ 'workspace.sitesbuilder.list.table.actions' | translate }}</th>
            </tr>
          </thead>
          <tbody *ngIf="sitesList?.length; else nolist">
            <tr *ngFor="let s of sitesList; index as i">
              <td>
                <button id="status-button" (click)="s.is_active ? disableSite(s) : enableSite(s)">
                  <i
                    class="fa fa-circle"
                    [ngClass]="{
                      is_active: s.is_active,
                      is_inactive: !s.is_active
                    }"></i>
                </button>
              </td>
              <td>
                {{ s.title }}
                <a [href]="s.url" target="_blank"><i class="fa fa-external-link"></i></a>
              </td>
              <td>{{ s.venue_code }} - {{ s.map_id }}</td>
              <td>{{ s.workflow.name }}</td>
              <td>
                <span *ngIf="libVersions && s.libversion !== libVersions.versions[0]"> ⚠ </span>{{ s.libversion }}
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <div class="me-3" *ngIf="s.updated_by">
                    <img
                      src="/assets/img/user.svg"
                      width="15"
                      class="c-pointer"
                      title="Modified by: {{ s.updated_by }}" />
                  </div>
                  <div>
                    {{ s.updated_at | date: 'dd/MM/yyyy hh:mm:ss' }}
                  </div>
                </div>
              </td>
              <td>
                <div class="td-centered">
                  <!-- Old Edit button -->
                  <!-- <button class="btn-action" (click)="redirectRefreshed('/sitesbuilder/admin/editor/'+s.workflow_id+'/'+s.id)">Editar</button> -->
                  <button class="btn-action-icon" (click)="openModalPreview(s)" title="Preview">
                    <i id="eye"></i>
                  </button>
                  <button
                    class="btn-action-icon"
                    (click)="redirectRefreshed('/sitesbuilder/private/editor/' + s.workflow_id + '/' + s.id)"
                    title="Editar"
                    [disabled]="s.redirect_url">
                    <i id="edit"></i>
                  </button>
                  <button class="btn-action-icon" (click)="onCredential(s)" title="Credenciales" [disabled]="s.redirect_url">
                    <!-- <img src="/assets/img/tools/credential.svg" alt=""> -->
                    <i id="key" aria-hidden="true"></i>
                  </button>
                  <button class="btn-action-icon" (click)="onCopy(s)" title="Duplicate">
                    <i id="duplicate"></i>
                  </button>
                  <button class="btn-action-icon" (click)="onRedirect(s)" title="Redirect">
                    <i id="redirect"></i>
                  </button>
                  <button class="btn-action-icon" (click)="onDelete(s)" title="Delete">
                    <i id="delete"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
          <ng-template #nolist>
            <tbody>
              <tr>
                <td colspan="6">No hay resultados</td>
              </tr>
            </tbody>
          </ng-template>
        </table>
      </div>

      <!-- Pagination -->
      <div *ngIf="pagination && sitesList.length" class="content-pagination">
        <button
          class="btn-page"
          [routerLink]="['/sitesbuilder/private/list']"
          [queryParams]="{ page: pagination.first_page }"
          [attr.disabled]="pagination.first_page === pagination.current_page ? '' : null">
          <i class="fa fa-angle-double-left"></i>
        </button>
        <button
          class="btn-page"
          [routerLink]="['/sitesbuilder/private/list']"
          [queryParams]="{ page: pagination.current_page - 1 }"
          [attr.disabled]="pagination.previous_page_url ? null : ''">
          <i class="fa fa-angle-left"></i>
        </button>
        <button class="btn-page current">
          {{ pagination.current_page }}
        </button>
        <button
          class="btn-page"
          [routerLink]="['/sitesbuilder/private/list']"
          [queryParams]="{ page: pagination.current_page + 1 }"
          [attr.disabled]="pagination.current_page === pagination.last_page ? '' : null">
          <i class="fa fa-angle-right"></i>
        </button>
        <button
          class="btn-page"
          [attr.disabled]="pagination.current_page === pagination.last_page ? '' : null"
          [routerLink]="['/sitesbuilder/private/list']"
          [queryParams]="{ page: pagination.last_page }">
          <i class="fa fa-angle-double-right"></i>
        </button>
      </div>

      <!-- Loading-->
      <div [hidden]="!loading" class="loading-wrapper">
        <div class="custom-loader"></div>
      </div>
    </div>
  </div>
</div>
